import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState } from 'react';

function useImageOnLoad() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoaded = _useState2[0],
      setIsLoaded = _useState2[1];

  var handleImageOnLoad = function handleImageOnLoad() {
    setIsLoaded(true);
  };

  var css = {
    thumbnail: {
      visibility: isLoaded ? 'hidden' : 'visible',
      filter: 'blur(8px)',
      transition: 'visibility 0ms ease-out 500ms'
    },
    fullSize: {
      opacity: isLoaded ? 1 : 0,
      transition: 'opacity 500ms ease-in 0ms'
    }
  };
  return {
    handleImageOnLoad: handleImageOnLoad,
    css: css
  };
}

export default useImageOnLoad;